import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const DiscoBall = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.094 7.077a7.67 7.67 0 0 1 5.15-1 7.62 7.62 0 0 1 4.576 2.537 7.46 7.46 0 0 1 1.82 4.866 7.46 7.46 0 0 1-1.805 4.87 7.62 7.62 0 0 1-4.569 2.552 7.67 7.67 0 0 1-5.152-.985 7.53 7.53 0 0 1-3.277-4.051A7.43 7.43 0 0 1 5 10.68m14.659-6.028v2.654M18.316 5.98H21m-15.658.442v2.654M4 7.749h2.684M8.474 2v2.653M7.132 3.327h2.684m2.237 3.98v12.382m2.783-.442a11.3 11.3 0 0 0 1.57-5.75c0-2.02-.541-4.003-1.57-5.748m-5.582 0a11.5 11.5 0 0 0-1.542 5.749c0 2.016.532 3.997 1.542 5.749m-3.458-5.742h12.527m-.448-2.749a11.65 11.65 0 0 0-5.815-1.553c-2.044 0-4.05.536-5.816 1.553m0 5.516a11.85 11.85 0 0 0 5.816 1.524c2.04 0 4.044-.525 5.815-1.524"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(DiscoBall) as SvgIcon;
export { ForwardRef as ReactComponent };
